/**
 * PROTOTYPE CONTENT — NOT VERIFIED. Restored verbatim from `design-reference/`.
 * The February 2026 registration date, the headcount, the contract count, the
 * registration and VAT numbers and the gradings are all invented. See
 * CONTENT-STATUS.md.
 */

/** The three body paragraphs on the About page. */
export const aboutBody = [
  'Samloryx Engineering is based in Burgersfort and was registered in February 2026. Today we are forty-one people, six contracts and one yard in Burgersfort — a new company built by people who are not new to this work.',
  'Our four directors bring between fourteen and nineteen years each on national roads, mine civils and municipal bulk services. What we are building deliberately is a contractor that self-performs: our own crews on the critical path, our own plant in the yard, and programme risk sitting with us rather than with a chain of subcontractors.',
  'We are graded CIDB 6CE and 6GB PE, which allows contracts up to R13 million. We intend to be graded higher by the end of 2027 — and to get there on completed work rather than on paper.',
]

/** Right-hand fact panel on the About page. */
export interface FactPanel {
  label: string
  /** Rendered one per line. */
  lines: string[]
}

export const aboutPanels: FactPanel[] = [
  {
    label: 'Registration',
    lines: ['Samloryx Engineering (Pty) Ltd', 'Reg. 2026/418772/07 · VAT 4290187336'],
  },
  {
    label: 'Gradings & status',
    lines: [
      'CIDB 6CE PE · 6GB PE (potentially emerging)',
      'B-BBEE Level 1 — EME, sworn affidavit',
      'ISO 45001 aligned; certification audit Q2 2027',
    ],
  },
  {
    label: 'Memberships',
    lines: [
      'SAFCEC and Master Builders SA — applications lodged',
      'SACPCMP and ECSA registered professionals on staff',
    ],
  },
]

/** Timeline strip. */
export interface Milestone {
  /** Short marker — a month or a year. */
  year: string
  text: string
}

export const timeline: Milestone[] = [
  { year: 'Feb', text: 'Samloryx Engineering (Pty) Ltd registered in Burgersfort by four directors.' },
  { year: 'Mar', text: 'CIDB submission lodged. Yard and first plant secured in Burgersfort.' },
  { year: 'May', text: 'Grade 6CE and 6GB PE confirmed. First contract signed — Erf 1140 earthworks.' },
  { year: 'Jul', text: 'First mining award in Emalahleni. Headcount reaches 41.' },
  { year: 'Aug', text: 'Order book at R48 m across six contracts in three provinces.' },
]

/** The four commitments. */
export interface Value {
  title: string
  text: string
}

export const values: Value[] = [
  {
    title: 'We self-perform',
    text: 'Our own crews on the critical path and our own plant in the yard. Subcontractors support the work; they do not carry it.',
  },
  {
    title: 'We price honestly',
    text: 'A tight number that fails at month eight helps nobody. Every estimate is built from first principles in Candy.',
  },
  {
    title: 'New company, not new people',
    text: 'The company is months old. The four directors running it bring between fourteen and nineteen years each.',
  },
  {
    title: 'We finish',
    text: 'Close-out, as-builts and defect liability are part of the job. Our reputation gets built on the last 5%, not the first.',
  },
]
